/**
 * Дизайн-система UI: единый источник Tailwind-классов.
 *
 * Палитра/радиусы/тени заданы токенами в tailwind.config.js. Здесь только
 * композиции классов, чтобы компоненты не дублировали длинные строки.
 */

/** Склейка классов с отбрасыванием falsy-значений. */
export const cx = (...p: Array<string | false | null | undefined>) => p.filter(Boolean).join(' ')

export const amount = 'tabular-nums'

export const card = 'rounded-panel border border-line bg-white p-4'
export const panel = 'rounded-card border border-line p-4'
export const title = 'm-0 text-huge font-bold text-ink'
export const hint = 'my-1.5 text-small text-muted'
export const label = 'flex flex-col gap-1 text-sm font-semibold'
export const input =
  'w-full rounded-card border border-lineStrong bg-white px-2.5 py-2 text-base2 text-ink outline-none placeholder:text-muted focus:border-info focus:ring-2 focus:ring-info/20'
export const select = cx(input, 'pr-8')
export const checkbox = 'h-4 w-4 accent-ok'

export const tableWrap = 'max-h-[360px] overflow-auto'
export const table = 'w-full border-collapse text-sm'
export const th =
  'sticky top-0 border-b border-line bg-soft px-2 py-1.5 text-left text-tiny font-semibold text-muted'
export const thNum = cx(th, 'text-right')
export const td = 'border-b border-line px-2 py-1.5 text-ink'
export const tdNum = cx(td, 'text-right tabular-nums')

export const chip =
  'inline-flex items-center gap-1 whitespace-nowrap rounded-md px-2 py-1 text-tiny font-semibold'
export const badge = {
  neutral: 'border border-line bg-white text-muted2',
  ok: 'border border-green-200 bg-green-50 text-green-800',
  warn: 'border border-amber-200 bg-amber-50 text-warnFg',
  danger: 'border border-warnLine bg-red-50 text-dangerDark',
  info: 'border border-sky-200 bg-sky-50 text-info'
}

export const btnBase =
  'inline-flex cursor-pointer items-center justify-center gap-2 rounded-card border font-semibold transition-colors active:brightness-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-info/30 disabled:cursor-not-allowed disabled:opacity-50'
export const btn = {
  primary: 'border-ink bg-ink text-white hover:bg-ink/90',
  success: 'border-ok bg-ok text-white hover:bg-okDark',
  secondary: 'border-lineStrong bg-white text-ink hover:bg-soft',
  ghost: 'border-transparent bg-transparent text-muted hover:bg-soft',
  danger: 'border-danger bg-danger text-white hover:bg-dangerDark',
  softDanger: 'border-warnLine bg-red-50 text-dangerDark hover:bg-red-100',
  dangerGhost: 'border-transparent bg-transparent text-danger hover:bg-red-50'
}
export const btnSize = {
  sm: 'px-2.5 py-1 text-small',
  md: 'px-3 py-2 text-sm',
  lg: 'px-4 py-3 text-base2'
}

export const overlay = 'fixed inset-0 flex items-center justify-center bg-ink/50 p-4'
export const modalSm = 'w-full max-w-[420px] rounded-panel bg-white p-6 shadow-modal'
export const modalLg =
  'w-full max-h-[90vh] max-w-[520px] overflow-y-auto rounded-panel bg-white p-6 shadow-modal'
export const modalTop = 'w-full max-w-[420px] rounded-panel bg-white p-6 shadow-modal'

export const fieldLabel = 'mb-3 flex flex-col gap-1 text-sm font-semibold text-ink'
export const fieldInput =
  'rounded-card border border-lineStrong px-2.5 py-2 text-base2 text-ink outline-none placeholder:text-muted focus:border-info focus:ring-2 focus:ring-info/20'

export const amountDisplay =
  'rounded-panel bg-surface px-4 py-3 text-center text-mega font-bold tabular-nums text-ink'
export const qrBox =
  'mx-auto flex min-h-[180px] w-full max-w-[240px] items-center justify-center rounded-panel border border-line bg-white p-2'
export const qrSvg = 'h-[220px] w-[220px]'
export const qrPayload = 'block break-all text-center text-tiny text-muted2'
export const row = 'flex items-center gap-2'
export const stack = 'flex flex-col gap-2'
